function TransferIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.83334 0.666648C4.83338 0.565875 4.80298 0.467439 4.74611 0.384246C4.68924 0.301053 4.60856 0.236986 4.51464 0.200444C4.42073 0.163901 4.31797 0.15659 4.21982 0.179468C4.12168 0.202345 4.03274 0.254345 3.96467 0.328648L0.298002 4.32865C0.232379 4.40018 0.188999 4.48927 0.173156 4.58505C0.157313 4.68082 0.169693 4.77914 0.208784 4.86799C0.247876 4.95685 0.311988 5.0324 0.393296 5.08544C0.474605 5.13847 0.569593 5.16669 0.666669 5.16665H11.3333C11.4659 5.16665 11.5931 5.11397 11.6869 5.0202C11.7807 4.92643 11.8333 4.79926 11.8333 4.66665C11.8333 4.53404 11.7807 4.40686 11.6869 4.31309C11.5931 4.21933 11.4659 4.16665 11.3333 4.16665H4.83334V0.666648ZM7.16667 11.3333V7.83331H0.666669C0.53406 7.83331 0.406883 7.78064 0.313115 7.68687C0.219347 7.5931 0.166669 7.46592 0.166669 7.33331C0.166669 7.20071 0.219347 7.07353 0.313115 6.97976C0.406883 6.88599 0.53406 6.83331 0.666669 6.83331H11.3333C11.4304 6.83327 11.5254 6.86149 11.6067 6.91452C11.688 6.96756 11.7521 7.04311 11.7912 7.13197C11.8303 7.22083 11.8427 7.31914 11.8268 7.41491C11.811 7.51069 11.7676 7.59978 11.702 7.67131L8.03534 11.6713C7.96726 11.7456 7.87832 11.7976 7.78018 11.8205C7.68204 11.8434 7.57927 11.8361 7.48536 11.7995C7.39145 11.763 7.31076 11.6989 7.25389 11.6157C7.19703 11.5325 7.16662 11.4341 7.16667 11.3333Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default TransferIcon
